import FaqService from "@/services/faq.service";
import { Module } from "vuex";
import { FaqCategory, FaqItem } from "@/models/FAQ";
import type { RootState } from "@/store";

const faqService = new FaqService();

export interface FaqState {
  categories: FaqCategory[];
  faqList: FaqItem[];
}

const faqModule: Module<FaqState, RootState> = {
  namespaced: true,
  state: () => ({
    categories: [],
    faqList: [],
  }),
  getters: {},
  mutations: {
    SET_CATEGORIES(state, payload) {
      state.categories = payload;
    },
    SET_FAQ_LIST(state, payload) {
      state.faqList = payload;
    },
  },
  actions: {
    fetchFaqData({ commit }) {
      return faqService
        .getFaqCategories()
        .then((catsResponse) => {
          const categories = (catsResponse.data.data as FaqCategory[])
            .filter((cat) => cat.publish === 1)
            .sort((a, b) => parseInt(a.priority) - parseInt(b.priority));
          commit("SET_CATEGORIES", categories);

          return faqService.getFaq();
        })
        .then((faqResponse) => {
          const faqList = (faqResponse.data.data as FaqItem[])
            .filter((faq) => faq.publish === 1)
            .sort((a, b) => parseInt(a.priority) - parseInt(b.priority));
          commit("SET_FAQ_LIST", faqList);
        })
        .catch((err) => {
          console.error(err);
          throw err;
        });
    },
  },
};

export default faqModule;
